module.exports = __webpack_public_path__ + "media/src/images/bg/bg3-3ea4ef615c94d1861f1a03025548d17b.jpg";